/**
 * Returns a boolean depending on whether we are in developer mode
 * @internal
 */
export function isDev(): boolean {
  return process.env.NODE_ENV === 'development';
}

/**
 * Returns a boolean depending on whether we are in production mode
 * @internal
 */
export function isProduction(): boolean {
  return process.env.NODE_ENV === 'production';
}

/**
 * Returns a boolean depending on whether we are in testing mode
 * @internal
 */
export function isTest(): boolean {
  return process.env.NODE_ENV === 'test';
}
